import {DocumentReviewEnum} from '../../enums/document-review.enum';

export class DocumentReviewDtoModel {
  "review": DocumentReviewEnum;

  constructor(data: any) {
    this.review = data.review;
  }
}
